/**
 * Generates a URL-safe, human-readable slug from arbitrary text.
 *
 * Used to derive deterministic entity IDs from user-entered names
 * (e.g. asset name → asset ID, policy name → policy ID).
 *
 * Rules:
 * - Lowercased
 * - German umlauts transliterated (ä→ae, ö→oe, ü→ue, ß→ss)
 * - Spaces and non-alphanumeric chars replaced with hyphens
 * - Consecutive hyphens collapsed
 * - Leading/trailing hyphens stripped
 *
 * @example slugify("Mein Test-Angebot")    → "mein-test-angebot"
 * @example slugify("Patient Data (v2)")    → "patient-data-v2"
 * @example slugify("Röntgen-Befunde März") → "roentgen-befunde-maerz"
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
